import request from './service/index'
export function login_Api(data){
    return request({
        url:'CMS/account/login',
        method:'post',
        
        data:data
    });
}


// WEBPACK FOOTER //
// ./src/apis/account.api.js